module.exports = __webpack_public_path__ + "static/img/guanCheOutNew.a61349e0.png";